import React from "react";
import { Link, useLocation, useNavigate, NavLink } from "react-router-dom";
import { SideBar } from "pepsico-ds";

import agm_1 from "../assets/side-navigation/agm_1.svg";
import ds_1 from "../assets/side-navigation/ds_1.svg";
import home_1 from "../assets/side-navigation/home_1.svg";
import idm_1 from "../assets/side-navigation/idm_1.svg";
import pki_1 from "../assets/side-navigation/pki_1.svg";
import sso_1 from "../assets/side-navigation/sso_1.svg";
import myidm_1 from "../assets/side-navigation/myidm_1.png";
import ciam from "../assets/side-navigation/CIAM.png";
import custom_icon from "../assets/side-navigation/power_BI_Logo.svg";
import { withTranslation } from "react-i18next";

export function withRouter(Component) {
  return function WrappedComponent(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

class SidebarView extends React.Component {
  constructor(props) {
    const userData = JSON.parse(localStorage.getItem("okta-token-storage"));
    const gpid = userData?.accessToken?.claims?.gpid;
    super(props);
    this.activeItem = null;
    this.state = {
      isCollapsed: props.isMobileMenuOpen,
      activeItem: "home",
      userProfile: null,
      gpid: gpid || null,
    };
  }


  componentDidMount() {
    // this.fetchData();
    const eles = document.getElementsByClassName("floating-menu-item");
    const pEle = document.querySelector(".floating-menu-container");
    for (const ele of eles) {
      ele.addEventListener("click", () => {
        pEle.classList.remove("visible");
        pEle.classList.add("hidden");
      });
    }
  }
  highlightSelection(item) {
    // dumy highlight function
  }

  // async fetchData() {
  //   let REACT_APP_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  //   try {
  //     const response = await axios.get(
  //       REACT_APP_API_ENDPOINT + "getUserProfile"
  //     );
  //     const result = await response?.data;
  //     this.setState({ isManager: result?.isManager });
  //   } catch (error) {
  //     this.setState({ isManager: false }); // Default to false in case of error
  //   }
  // }
  // test(params) {
  //   const items = document.querySelectorAll(".item-collapsed");
  // }

  isSidebarCollapsed = () => {
    const sidebar = document.querySelector(".sidebar");
    return sidebar?.classList.contains("collapsed");
  };

  navigateToRoute = (url) => {
    if (url === '/reports') {
      // const navigate = useNavigate();
      // navigate('/reports');
      this.props.navigate(url);
      return;
    }
    if (url == 'myidmPortal') {
      // const navigate = useNavigate();
      this.props.navigate('/myidmPortal');
    }
    if (url == 'extension-request') {
      this.props.navigate('/extension-request');
    }
    if (url == 'single-extension-reactivation') {
      this.props.navigate('/single-extension-reactivation');
    }
    if (url == 'bulk-revalidation') {
      this.props.navigate('/bulk-revalidation');
    }
    if (url == 'change_password') {
      // const navigate = useNavigate();
      this.props.navigate('/change-password')
    }
    if (url == 'request_access') {
      // const navigate = useNavigate();
      this.props.navigate('/request_access')
    }
    if (url == 'request_access_others') {
      // const navigate = useNavigate();  
      this.props.navigate('myidmPortal',{ navigateFrom: 'request_access_others' })
    }
    else if (window.location.pathname === url) {
      return;
    }
    this.props.navigate(url);
    // window.location.href = url;
  };

  render() {
    // console.log("SidebarView props", this.props);
    // console.log("state", this.props?.userProfile?.pepappiamcentralroles);
    const { isCollapsed, activeItem } = this.state;
    const isManager = this.props.isManager ?? false;
    const { userProfile } = this.props;
    const { t } = this.props;
    const managerSublinks = [
      {
        label: (
          <Link to="/change-password" disabled
          className={`${userProfile?.systemsStatus?.myidM ? "disabled" : ""}`}
          // onClick={() => this.navigateToRoute("change-password")}
          >
            {t("menu.change_password")}
          </Link>
        ),
      },
      {
        label: (
          userProfile?.pepappiamcentralfeatures?.includes("RequestAccess") ?
          <Link to="/request-access">
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}> 
            {t("menu.request_access")}
            </span>
          </Link> :
          <Link
          onClick={() =>{ 
            (
              window.open(
              "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestNewAccessForSelf",
              "_blank"
            )
          )
          }} 
        >
          <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}> 
          {t("menu.request_access")}
          </span>
        </Link>
        ),
      },
      ...((userProfile?.associateType?.toLowerCase() !== "thirdparty") ? [{
        label: (
          userProfile?.pepappiamcentralfeatures?.includes('RequestAccess') ?
          <Link to="/myidmPortal" state={{ navigateFrom: 'request_access_others' }}>
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
            {t("menu.request_access_others")}
            </span>
          </Link> :
          <Link 
          onClick={() =>{
            window.open(
              "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestAccessForOtherAssociate",
              "_blank"
            )
          }
          } 
        >
          <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
          {t("menu.request_access_others")}
          </span>
        </Link>
        ),
      }]:[]),
      ...(userProfile?.isIREnabled ? [{
        label: (
          <Link to="/ir-suspend-service-account">
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
            {t("ir.suspend_service_account")}
            </span>
          </Link>
        )
      }]:[]),
      ...((userProfile?.associateType?.toLowerCase() === "contractor" ||
        userProfile?.associateType?.toLowerCase() === "thirdparty") ? [{
        label: (
          userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation') ?
          <Link to="/extension-request">
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
            {t("homePage.extension_self")}
            </span>
          </Link>:
          <Link 
          onClick={() =>{ (
              window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ExtensionReactivationNonEmployeeSelfRequest","_blank")
              )
          }} 
          >
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
            {t("homePage.extension_self")}
            </span>
          </Link>
        ),
      }]:[]),
      ...(userProfile?.associateType?.toLowerCase() !== "thirdparty" ? [{
        label: (
          userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation') ?
          <Link to="/single-extension-reactivation">
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
            {t("homePage.extension_others")}
            </span>
          </Link>:
          <Link
          onClick={() => {
                window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ExtensionReactivationforAnotherNonEmployee","_blank")
          }}
          >
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
            {t("homePage.extension_others")}
            </span>
          </Link>
        ),
      }]:[]),
      
      // {
      //   label: (
      //     <Link
      //       onClick={() => {
      //         this.navigateToRoute('myidm-1')
      //       }}
      //     >
      //       myidM
      //     </Link>
      //   ),
      // },

      ...(isManager ? [{
        label: (
          userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation') ?
          <Link to="/bulk-revalidation">
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
            {t("homePage.bulk_revalidation")}
            </span>
          </Link> :
          <Link
          onClick={() => { 
            (
              window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoBulkRevalidationNonEmployee","_blank")
              ) 
          }
          } 
          >
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
            {t("homePage.bulk_revalidation")}
            </span>
          </Link>
        ),
      }]:[]),
      {
        label: (
          <Link
            onClick={() => {
              window.open(
                "https://myidm.mypepsico.com/pepsicorao/request/application",
                "_blank"
              );
            }}
          >
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
            App Onboarding
            </span>
          </Link>
        ),
      },
      {
        label: (
          <Link to="/app-retirement">
            <span
              className={`${
                userProfile?.systemsStatus?.DS ? "disabled-card" : ""
              }`}
            >
              {t("app_retirement.application_retirements")}
            </span>
          </Link>
        )
      },
      {
        label: (
          <Link to="/myidmPortal"
            // onClick={() => {
            //   this.navigateToRoute('myidmPortal')
            // }}
          >
            <span style={{color: "#007bff", fontWeight: "bold"}}>View More Options</span>
          </Link>
        ),
      },
    ];
    const nonManagerSubLinks = [
      {
        label: (
          <Link to="/change-password"
            // onClick={() => {
            //   this.navigateToRoute('change-password')
            // }}
          >
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>

            {t("menu.change_password")}
            </span>
          </Link>
        ),
      },
      {
        label: (
          userProfile?.pepappiamcentralfeatures?.includes("RequestAccess")?
          <Link to="/request-access">
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}> 
            {t("menu.request_access")}
            </span>
          </Link> :
          <Link
          onClick={() =>{ 
            (
              window.open(
              "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestNewAccessForSelf",
              "_blank"
            )
          )
          }} 
        >
          <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}> 
          {t("menu.request_access")}
          </span>
        </Link>
        ),
      },
      // {
        ...((userProfile?.associateType?.toLowerCase() !== "thirdparty") ? [{
          label: (
            userProfile?.pepappiamcentralfeatures?.includes('RequestAccess') ?
            <Link to="/myidmPortal" state={{ navigateFrom: 'request_access_others' }}>
              <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
              {t("menu.request_access_others")}
              </span>
            </Link> :
            <Link 
            onClick={() =>{
              window.open(
                "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestAccessForOtherAssociate",
                "_blank"
              )
            }
            } 
          >
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
            {t("menu.request_access_others")}
            </span>
          </Link>
          )
      }]:[]),  
      ...(userProfile?.isIREnabled ? [{
        label: (
          <Link to="/ir-suspend-service-account">
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
            {t("ir.suspend_service_account")}
            </span>
          </Link>
        )
      }]:[]),
      ...((userProfile?.associateType?.toLowerCase() === "contractor" ||
        userProfile?.associateType?.toLowerCase() === "thirdparty") ? [{
        label: (
          userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation') ?
          <Link to="/extension-request">
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
              {t("homePage.extension_self")}
            </span>
          </Link> :
          <Link 
          onClick={() =>{
            (
              window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ExtensionReactivationNonEmployeeSelfRequest","_blank")
            )
          }}
          >
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
              {t("homePage.extension_self")}
            </span>
          </Link>
        ),
      }]:[]),
      ...(userProfile?.associateType?.toLowerCase() !== "thirdparty" ? [{
        label: (
          userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation') ?
          <Link to="/single-extension-reactivation">
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
              {t("homePage.extension_others")}
            </span>
          </Link>:
          <Link 
          onClick={() => {(
              window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ExtensionReactivationforAnotherNonEmployee","_blank")
              ) 
        }}
          >
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
              {t("homePage.extension_others")}
            </span>
          </Link>
        ),
      }]:[]),

      ...(isManager ? [{
        label: (
          userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation') ?
          <Link to="/bulk-revalidation">
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
              {t("homePage.bulk_revalidation")}
            </span>
          </Link> :
          <Link
          onClick={() => { 
            (
              window.open("https://myidm.ite.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoBulkRevalidationNonEmployee","_blank")
              ) 
          }
          } 
          >
            <span className={`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}>
              {t("homePage.bulk_revalidation")}
            </span>
          </Link>
        ),
      }] : []),
      {
        label: (
          <Link to="/app-retirement">
            <span
              className={`${
                userProfile?.systemsStatus?.DS ? "disabled-card" : ""
              }`}
            >
              {t("app_retirement.application_retirements")}
            </span>
          </Link>
        )
      },
      {
        label: (
          <Link to="/myidmPortal"
            // onClick={() => {
            //   this.navigateToRoute('myidmPortal')
            // }}
          >
            <span style={{color: "#007bff", fontWeight: "bold"}}>View More Options</span>
          </Link>
        ),
      },
    ];
    // Conditional rendering for sublinks based on isManager state
    const myidmSublinks =
      isManager === null
        ? []
        : isManager
          ? managerSublinks
          : nonManagerSubLinks;
    const sidebarItems = [
      {
        icon: (
          <img
            src={activeItem === "home" ? home_1 : home_1}
            style={{
              width: "25px",
              height: "25px",
              "flex-shrink": "0",
              "aspect-ratio": "25.00 / 25.00",
            }}
            onClick={() => this.navigateToRoute("/home")}
          />
        ),
        label: (
          <Link to="/home" className="home-side-menu" 
          // onClick={() => this.navigateToRoute("/home")}
          >
            {t("menu.home")}
          </Link>
        ),
        url: "/home",
        id: "home",
      },
      {
        icon: (
          <img
            src={activeItem === "myidM" ? myidm_1 : myidm_1}
            style={{
              width: "25px",
              height: "25px",
              "flex-shrink": "0",
              "aspect-ratio": "25.00 / 25.00",
            }}
          />
        ),
        label: "myidM",
        sublinks: myidmSublinks,
        id: "myidM",
        url: "/",
      },
      {
        icon: (
          <img
            src={activeItem === "sso" ? sso_1 : sso_1}
            style={{
              width: "25px",
              height: "25px",
              "flex-shrink": "0",
              "aspect-ratio": "25.00 / 25.00",
            }}
            alt="SSO"
          />
        ),
        label: "SSO",
        url: "/",
        id: "sso",
        sublinks: [
          {
            label: (
              userProfile?.pepappiamcentralfeatures?.includes('SSOOnboarding') ?
              <Link to="/sso-onboarding">
                <span className={`${userProfile?.systemsStatus?.SSO ? "disabled-card" : ""}`}>
                  {t("menu.sso_app_onboarding")}
                </span>
              </Link> :
              <Link
                onClick={() => {
                  window.open(
                    "https://devx-infra.mypepsico.com/sso-okta-onboarding",
                    "_blank",
                    "noopener noreferrer"
                  );
                }}
              >
                <span className={`${userProfile?.systemsStatus?.SSO ? "disabled-card" : ""}`}>
                  {t("menu.sso_app_onboarding")}
                </span>
              </Link>
            ),
          },
          {
            label: (
              userProfile?.pepappiamcentralfeatures?.includes('SSOModification') ?
              <Link to="/sso-modification">
                <span className={`${userProfile?.systemsStatus?.SSO ? "disabled-card" : ""}`}>
                  {t("menu.sso_app_modification")}
                </span>
              </Link> :
              <Link
                onClick={() => {
                  window.open(
                    "https://devx-infra.mypepsico.com/sso-okta-modification",
                    "_blank",
                    "noopener noreferrer"
                  );
                }}
              >
                <span className={`${userProfile?.systemsStatus?.SSO ? "disabled-card" : ""}`}>
                  {t("menu.sso_app_modification")}
                </span>
              </Link>
            ),
          },
          {
            label: (
              <Link
                onClick={() => {
                  window.open(
                    "https://secure.pepsico.com/enduser/settings"
                  );
                }}
              >
                <span className={`${userProfile?.systemsStatus?.SSO ? "disabled-card" : ""}`}>
                  {t("menu.update_mfa_factors")}
                </span>
              </Link>
            ),
          },
        ],
      },
      {
        icon: (
          <img
            src={activeItem === "pepAGM" ? agm_1 : agm_1}
            style={{
              width: "25px",
              height: "25px",
              "flex-shrink": "0",
              "aspect-ratio": "25.00 / 25.00",
            }}
            alt="pepAGM"
          />
        ),

        label: "pepAGM",
        sublinks: [
          {
            label: (
              <Link
                onClick={() => {
                  window.open(
                    "https://pepagm.mypepsico.com/sigma/app/index#/campaigns",
                    "_blank"
                  );
                }}
              >
                <span className={`${userProfile?.systemsStatus?.pepAGM ? "disabled-card" : ""}`}>
                  {t("menu.pepagm")}
                </span>
              </Link>
            ),
          },
          {
            label: (
              <Link
                onClick={() => {
                  window.open(
                    "https://www.mypepsico.com/wps/myportal/web/MyPepsiCo/company/systems-and-applications/pepagm/resources/!ut/p/z1/tVNdb5swFP0re8mj5Qs2YB4pTT_o6MdSEvALMuAQqtjQQL_262e6VpumJWzaalm2bJ17ru_xuZjjFHMtHptaDE2rxdacM-7m12zunkVgX1x5HkCwvPLhZHESMM_Fq1dAfGq51hGFz3ALBmBFATu-YGBRB_P98ae35C0e9owApuKXmGO-FboON2aROJN6vOnKpsIZlJUj_LVAjBY2otIqke8WHiptSd3CTCb9EV3qoRs2OFNd_iSLvGz1IPWQb5sil3oG7cPuU9mqTuiXGfQv_SBVL3Qlum7blK9K9TPoZCdqNYOd7A2-lP1baQfezv9E2gMAfli51VjaxOdMcfBfHnk-n0NwBMsbGvoQHtOJFLaFM1OFt1cF4uDVYyOfcKLbnTKGW4yMqzDOb5L5FxO772uJAFJYPkEWqQpEmUtQwaiDCGF0XTkF2ILiM5hIH8FHpo-mzGu6y97FYVwbWjFsUKPXLU5F0T4M6LufcPq-46y5u7_ngXHraM_nAaf_w64_J3u_xQtT6kHh2KX9O-H-ousm6J1_pI-mmuuj9PzR_p1KEsWIQkkKzTnKoruv602tri8Rz9jA4jlxapXH_TekQCwD/dz/d5/L2dBISEvZ0FBIS9nQSEh/",
                    "_blank"
                  );
                }}
              >
                <span className={`${userProfile?.systemsStatus?.pepAGM ? "disabled-card" : ""}`}>
                  {t("menu.pepagm_help_resources")}
                </span>
              </Link>
            ),
          },
        ],
        id: "pepAGM",
        url: "/",
      },
      {
        icon: (
          <img
            src={activeItem === "pki" ? pki_1 : pki_1}
            style={{
              width: "25px",
              height: "25px",
              "flex-shrink": "0",
              "aspect-ratio": "25.00 / 25.00",
            }}
            alt="Pepsico"
          />
        ),
        label: "PKI",
        disabled: true,
        sublinks: [
          {
            label: (
              <Link
                onClick={() => {
                  window.open(
                    "https://mycert-pepsico.appvx.com/appviewx/login",
                    "_blank"
                  );
                }}
              >
                <span className={`${userProfile?.systemsStatus?.PKI ? "disabled-card" : ""}`}>
                  {t("menu.mycert_portal")}
                </span>
              </Link>
            ),
          },

          {
            label: (
              <Link
                onClick={() => {
                  window.open(
                    "https://pepsico.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=68fac3dc83c85ed02eeef1a8beaad390&sysparm_link_parent=11d60ce50f511700fa1b1b1e51050e82&sysparm_catalog=e0d08b13c3330100c8b837659bba8fb4&sysparm_catalog_view=catalog_default&sysparm_view=catalog_default",
                    "_blank"
                  );
                }}
              >
                <span className={`${userProfile?.systemsStatus?.PKI ? "disabled-card" : ""}`}>
                  {t("menu.mycert_requests")}
                </span>
              </Link>
            ),
          },
          {
            label: (
              <Link
                onClick={() => {
                  window.open(
                    "https://pepsico.sharepoint.com/sites/myCert/userportal/SitePages/Home.aspx",
                    "_blank"
                  );
                }}
              >
                <span className={`card-content pad-left-0 pb-0 ${userProfile?.systemsStatus?.PKI ? "disabled-card" : ""}`}>
                  {t("menu.mycert_help")}
                </span>
              </Link>
            ),
          }, {
            label: (
              <Link to="/pki-certificates"
                // onClick={() => {
                //   window.open(
                //     "https://mycert-pepsico.appvx.com/appviewx/app#certificate/insights/summary",
                //     "_blank"
                //   );
                // }}
              >
                <span className={`${userProfile?.systemsStatus?.PKI ? "disabled-card" : ""}`}>
                  {t("menu.certificate_expiry_dashboard_summary_insights")}
                </span>
              </Link>
            ),
          },
        ],
        id: "pki",
        url: "/",
      },
      {
        icon: (
          <img
            src={activeItem === "pepAGM" ? idm_1 : idm_1}
            style={{
              width: "25px",
              height: "25px",
              "flex-shrink": "0",
              "aspect-ratio": "25.00 / 25.00",
            }}
            alt="pepAGM"
          />
        ),

        label: "myPAM",
        sublinks: [
          {
            label: (
              <Link
                onClick={() => {
                  window.open(
                    "https://mypam.intra.pepsico.com",
                    "_blank",
                    "noopener noreferrer"
                  );
                }}
              >
                <span className={`card-content pad-left-0 pb-0 ${userProfile?.systemsStatus?.myPAM ? "disabled-card" : ""}`}>
                myPAM
                </span>
              </Link>
            ),
          },
          {
            label: (
              <Link to="/pam-svc-account">
                <span className={`card-content pad-left-0 pb-0 ${userProfile?.systemsStatus?.myPAM ? "disabled-card" : ""}`}>
                {t("menu.mypam_svc_onboard")}
                </span>
              </Link>
            ),
          },
          ...(userProfile?.pepappiamcentralfeatures?.includes("SafeManagement") ? [{
            label: (
              <Link to="/pam-safe-create-update">
                <span className={`card-content pad-left-0 pb-0 ${userProfile?.systemsStatus?.myPAM ? "disabled-card" : ""}`}>
                {t("mypam.safe_management")}
                </span>
              </Link>
            ),
          }
          // ,
          // {
          //   label: (
          //     <Link to="/pam-safe-access-request">
          //       <span className={`card-content pad-left-0 pb-0 ${userProfile?.systemsStatus?.myPAM ? "disabled-card" : ""}`}>
          //       {t("mypam.myPAM_safe_access_request")}
          //       </span>
          //     </Link>
          //   ),
          // }
        ] : [] ),
          ...(userProfile?.pepappiamcentralfeatures?.includes("PamSVCApproval") ? [{
            label: (
              <Link to="/pam-svc-account-approval">
                <span className={`card-content pad-left-0 pb-0 ${userProfile?.systemsStatus?.myPAM ? "disabled-card" : ""}`}>
                {t("menu.mypam_svc_onboard_approval")}
                </span>
              </Link>
            ),
          }]:[])
        ],
        id: "myPAM",
        url: "https://mypam.mypepsico.com/",
      },
      {
        icon: (
          <img
            src={activeItem === "directory_services" ? ds_1 : ds_1}
            style={{
              width: "25px",
              height: "25px",
              "flex-shrink": "0",
              "aspect-ratio": "25.00 / 25.00",
            }}
            alt="Directory Services"
          />
        ),
        label: t("menu.directory_services"),
        sublinks: [
          ...(userProfile?.pepappiamcentralfeatures?.includes('ADDashboard') ? [{
            label: (
              <Link to="/active-directory">
                <span className={`${userProfile?.systemsStatus?.DS ? "disabled-card" : ""}`}>
                {t("homePage.active_directory_dashboard")}
                </span>
              </Link>
            ),
          }] : []),
          ...((userProfile?.associateType?.toLowerCase()?.includes("employee") && userProfile?.pepappiamcentralfeatures?.includes("GuestInvitation")) ? [{
            label: (
              <Link to="/guest-invitation-request">
                <span className={`${userProfile?.systemsStatus?.DS ? "disabled-card" : ""}`}>
                {t("homePage.m365_guest_invitation_request")}
                </span>
              </Link>
            ),
          },
          {
            label: (
              <Link to="/guest-management">
                <span className={`${userProfile?.systemsStatus?.DS ? "disabled-card" : ""}`}>
                {t("homePage.m365_guest_management")}
                </span>
              </Link>
            ),
          }] : []),
          ...(userProfile?.pepappiamcentralfeatures?.includes('EntraAppRegistration') ? [{
            label: (
            <Link to="/app-registration">
              <span
                className={`${
                  userProfile?.systemsStatus?.DS ? "disabled-card" : ""
                }`}
              >
                {t("app_registeration.entra_azure_application_registeration")}
              </span>
            </Link>
          ),
          }] : []),
          ...((userProfile?.pepappiamcentralfeatures?.includes("AttributeBulkLoad")) ? [{
            label: (
              <Link to="/idx-bulk-load">
                <span className={`${userProfile?.systemsStatus?.DS ? "disabled-card" : ""}`}>
                {t("idx.attribute_bulk_load")}
                </span>
              </Link>
            ),
          }] : []),
          ...((userProfile?.pepappiamcentralfeatures?.includes("SelfReporting")) ? [{
            label: (
              <Link to="/idx-self-service">
                <span className={`${userProfile?.systemsStatus?.DS ? "disabled-card" : ""}`}>
                {t("idx.reporting_self_service")}
                </span>
              </Link>
            ),
          }] : []),
          ...(userProfile?.pepappiamcentralfeatures?.includes("IDXITEPasswordReset") ? [{
            label: (
              <Link
                // onClick={() => {
                //   window.open(
                //     "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=IDXITEPasswordreset",
                //     "_blank"
                //   );
                // }}
                to="/idx-preprod-password-reset"
              >
                <span className={`${userProfile?.systemsStatus?.DS ? "disabled-card" : ""}`}>
                {t("homePage.idx_test_account_reset")}
                </span>
              </Link>
            ),
          }] : []),
          {
            label: (
              <Link
                onClick={() => {
                  window.open(
                    "https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3Defbdd2f047b6a2102d2b30ffe16d439c%26sysparm_link_parent%3D18c548650f511700fa1b1b1e51050ef5%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_default%26sysparm_view%3Dcatalog_default",
                    "_blank"
                  );
                }}
              >
                <span className={`${userProfile?.systemsStatus?.DS ? "disabled-card" : ""}`}>
                {t("menu.myits_service_request")}
                </span>
              </Link>
            ),
          },
          // {
          //   label: (
          //     <Link
          //       onClick={() => {
          //         window.open(
          //           "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=IdxTestIdCreation",
          //           "_blank"
          //         );
          //       }}
          //     >
          //       <span className={`${userProfile?.systemsStatus?.DS ? "disabled-card" : ""}`}>
          //       {t("homePage.idx_test_id_creation")}
          //       </span>
          //     </Link>
          //   ),
          // },

          ...(userProfile?.pepappiamcentralfeatures?.includes("IDXTestIDCreation")
  ? [{
      label: (
        <Link to="/idx-testid-request-preprod">
          <span className={`${userProfile?.systemsStatus?.DS ? "disabled-card" : ""}`}>
            {t("homePage.idx_test_id_creation")}
          </span>
        </Link>
      ),
    }]
  : []),

  ...(userProfile?.pepappiamcentralfeatures?.includes("IDXGroupMember")
  ? [{
      label: (
        <Link to="/idx-preprod-group-membership">
          <span className={`${userProfile?.systemsStatus?.DS ? "disabled-card" : ""}`}>
            {t("idx.idx_preprod_group_membership")}
          </span>
        </Link>
      ),
    }]
  : []),

...(userProfile?.pepappiamcentralfeatures?.includes("IDXITEAppAccess") ? [{
  label: (
    <Link to="/idx-preprod-application-access">
      <span
        className={`${
          userProfile?.systemsStatus?.DS ? "disabled-card" : ""
        }`}
      >
        {t("idx.preprod_application_access")}
      </span>
    </Link>
  ),
}] : []),

//   {
//   label: (
//     <Link to="/idx-preprod-password-reset">
//       <span className={`${userProfile?.systemsStatus?.DS ? "disabled-card" : ""}`}>
//         {t("idx.idx_preprod_password_reset")}
//       </span>
//     </Link>
//   ),
// },

        ],
        id: "directory_services",
        url: "/",
      },
      {
        icon: (
          <img
            src={activeItem === "ciam" ? ciam : ciam}
            style={{
              width: "25px",
              height: "25px",
              "flex-shrink": "0",
              "aspect-ratio": "25.00 / 25.00",
            }}
            alt="CIAM"
          />
        ),
        label: "CIAM",
        sublinks: [
          {
            label: (
              <Link
                onClick={() => {
                  window.open(
                    "https://forms.office.com/r/5chXKfaF5w",
                    "_blank"
                  );
                }}
              >
                <span className={`${userProfile?.systemsStatus?.CIAM ? "disabled-card" : ""}`}>
                {t("homePage.ciam_submit_request")}
                </span>
              </Link>
            ),
          },
          {
            label: (
              <Link
                onClick={() => {
                  window.open(
                    "https://secure-admin-partner.pepsico.com/",
                    "_blank"
                  );
                }}
              >
                <span className={`${userProfile?.systemsStatus?.CIAM ? "disabled-card" : ""}`}>
                {t("homePage.ciam_onboard_request")}
                </span>
              </Link>
            ),
          }
        ],
        id: "ciam",
        url: "/",
      },
    ]
    // if (this.props?.roles?.includes("powerBI")) {
      // if (this.state.feature.chat === ") {
      // if(JSON.parse(localStorage.getItem("roles"))?.powerBI) {
      sidebarItems.push({
        icon: (
          <img
            src={custom_icon}
            style={{
              width: "25px",
              height: "25px",
              flexShrink: "0",
              aspectRatio: "25.00 / 25.00",
            }}
            alt="Custom Feature"
            onClick={() => this.navigateToRoute("/reports")}
          />
        ),
        label: (
          <Link to="/reports" className="home-side-menu"
          // onClick={() => this.navigateToRoute("/reports")}
          >
            <span>{t("homePage.more_info_PBI")}</span>
          </Link>
        ),
        url: "/reports",
        id: "specialFeature",
      });
    // }
    return (
      <div className="main-sidebar">
        <SideBar
          activeItem={{
            icon: "home",
            label: <Link to="/home"> {t("menu.home")}</Link>,
            url: "/home",
            activeItem: true,
          }}

          items={sidebarItems}
          showCollapsed={isCollapsed}
          isShow={true}
          navLinkAction={(item) => {
            if(item?.sublinks?.length>0) return;
            if((item?.url && item?.url !== '/') || item?.label?.props?.to){
              const hamburger = document.querySelector(".sidebar-columns .sidebar-content .item-expanded.sidebar-hamburger")
              console.log("call", item)
              if(hamburger){
                hamburger?.click?.();
                this.props?.isMobile && this.props?.showMenu(false)
              }
            }
          }
        }
        />
      </div>
    );
  }
}

export default withRouter(withTranslation()(SidebarView));
